// extracted by mini-css-extract-plugin
export default {"serviceTeaser":"service-teaser-module--service-teaser--ca436","serviceTeaserIcon":"service-teaser-module--service-teaser-icon--617b2"};